import React, { useRef, useState, useEffect } from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import FormControl from '@mui/material/FormControl'
import { SelectChangeEvent } from '@mui/material/Select'
import ObjMTag from './TagObjctfMaturite'
import { useTranslation } from 'react-i18next'
import { maturiteLabels } from '../../utils/constants'
import Select, { SingleValue } from 'react-select'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'
import i18n from '../../i18n'

interface SelectStatusProps {
  value: string
  onChange: (event: SelectChangeEvent<string>, child?: React.ReactNode) => void
  hideLabel?: boolean
}

const SelectobjMaturite: React.FC<SelectStatusProps> = ({
  value,
  onChange,
  hideLabel = true,
}) => {
  const menu = useExclusiveMenu()
  const { t } = useTranslation()
  const containerRef = useRef<HTMLDivElement>(null)


  const selectOptions = Object.keys(maturiteLabels).map((key) => {
    const labels = maturiteLabels[key]
    const lang = (i18n.language || 'en').startsWith('fr') ? 'fr' : 'en'
    return {
      value: key,
      label: labels?.[lang] || key,
    }
  })

  const selectedOption =
    selectOptions.find((opt) => opt.value === value) || null

  const handleSelectChange = (
    selected: SingleValue<{ value: string; label: string }>
  ) => {
    const event = {
      target: { value: selected ? selected.value : '' },
    } as SelectChangeEvent<string>
    onChange(event)
  }

  return (
    <div ref={containerRef} style={{ width: '100%', position: 'relative' }}>
      {!hideLabel ? (
        <label
          style={{
            position: 'absolute',
            top: '-8px',
            left: '12px',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.6)',
            backgroundColor: 'white',
            padding: '0 4px',
            zIndex: 60,
          }}
        >
          {t('Maturity')}
        </label>
      ) : null}
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select
          value={selectedOption}
          onChange={handleSelectChange}
          options={selectOptions}
          formatOptionLabel={(option) => (
            <ObjMTag objectifM={option.value} />
          )}
          placeholder={t('Maturity')}
          styles={incyiaSelectStyles}
          {...menu}
          isMulti={false}
        />
      </FormControl>
    </div>
  )
}

export default SelectobjMaturite
